import {FC, MouseEvent, useState} from 'react'
import {storeBooking} from "../../lib/booking";
import {formatSlug} from "../../lib/helpers";

interface Props {
    option:any,
    booking:Booking,
    setBooking:Function
}

const Mercedes: FC<Props> = ({option, booking, setBooking}) => {

    const debug = false
    const [code, setCode] = useState(booking.options_extra.volvo_pst)
    const updateField = (e: any) => {
        setCode(e.target.value)
        booking.options_extra.mercedes_code = e.target.value
        storeBooking(booking, setBooking)
    }

    if(!debug) {
        if (formatSlug(booking.car.brand) !== 'mercedes-benz' || !option.active || booking.booking_flow === 'hjulskifte') {
            return
        }

        // Do not show option when booking only includes hjulskifte (service product)
        if (booking.service.slug.includes('hjulskifte')) {
            return
        }
    }

    const openInfo =  (event: MouseEvent) => {
        booking.modal = 13;
        booking.modal_message = option.info
        storeBooking(booking, setBooking)
    }

    return (
        <>
            <ul className="wco-order-options_list brand-extra-option">
                <li className="volvo-mechanic input-outer chk-box">
                    <div className="li-text">
                        <div className="description mercedes-service-code">
                            <h3>{option.header}</h3>
                            <div className="wco-info mercedes-service-code__info">
                                <i className="far fa-info-circle" aria-hidden="true" onMouseDown={(event) => openInfo(event)}></i>
                            </div>
                        </div>
                        {option.description && (
                            <div className={'mb-2'}>{option.description}</div>
                        )}
                        <div className="input-outer">
                            <label htmlFor="service_code">{option.label}</label>
                            <input id="service_code" type="text" name="service_code" placeholder={option.placeholder} value={code} onChange={updateField}/>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
};

export default Mercedes
